import { Button, Grid, TextField } from "@mui/material";
import Card from "@mui/material/Card";
import React, { useState } from "react";
import { API_ENDPOINTS } from "src/Utils/ApiConstants/ApiUrlConstants";
import * as XLSX from "xlsx";
import { LoggedInSkeleton } from "../Common/LoggedInSkeleton";
import { getAdminTopBarButtons } from "../Common/TopNavBar";
import useFetch from "../Common/useFetch";
import Table from "../ReactTable/Table";
import "./Admin.scss";
import { ListLedgerResponse } from "./AdminInterfaces";
import IndeterminateCheckbox from "./IndeterminateCheckbox";

const SapData = () => {
  const [rowsData, setRowsData] = useState<any[]>([]);
  const [selectedRow, setSelectedRow] = useState<any>([]);
  const [actorId, setActorId] = useState<number>(null);
  const [businessPartnerCode, setBusinessPartnerCode] = useState<number>(null);

  const columnDefinition = React.useMemo(
    () => [
      {
        id: "selection",
        // The header can use the table's getToggleAllRowsSelectedProps method
        // to render a checkbox
        Header: ({ getToggleAllRowsSelectedProps }: any) => (
          <div>
            <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
          </div>
        ),
        // The cell can use the individual row's getToggleRowSelectedProps method
        // to the render a checkbox
        Cell: ({ row }: any) => (
          <div>
            <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
          </div>
        ),
        minWidth: 50,
        maxWidth: 50,
        width: 50,
      },
      {
        Header: "LineId",
        accessor: "lineId",
        Sort: true,
        minWidth: 90,
        maxWidth: 90,
        width: 90,
      },
      {
        Header: "OwnId",
        accessor: "ownId",
        Sort: true,
        minWidth: 100,
        maxWidth: 100,
        width: 100,
      },
      {
        Header: "BusinessPartnerId",
        accessor: "businessPartnerId",
        Sort: true,
        minWidth: 180,
        maxWidth: 180,
        width: 180,
      },

      {
        Header: "DocumentNumber",
        accessor: "documentNumber",
        Sort: true,
        minWidth: 200,
        maxWidth: 200,
        width: 200,
      },
      {
        Header: "DocumentType",
        accessor: "documentType",
        Sort: true,
        minWidth: 200,
        maxWidth: 200,
        width: 200,
      },
      {
        Header: "DocumentDate",
        accessor: "documentDate",
        Sort: true,
        minWidth: 350,
        maxWidth: 350,
        width: 350,
      },
      {
        Header: "PostingDate",
        accessor: "postingDate",
        Sort: true,
        minWidth: 350,
        maxWidth: 350,
        width: 350,
      },
      {
        Header: "Amount",
        accessor: "amount.amount",
        Sort: true,
        minWidth: 200,
        maxWidth: 200,
        width: 200,
      },
      {
        Header: "Reference",
        accessor: "reference",
        Sort: true,
        minWidth: 200,
        maxWidth: 200,
        width: 200,
      },
    ],
    []
  );

  const getListLedger = async () => {
    await useFetch<ListLedgerResponse>(API_ENDPOINTS.LIST_LEDGER.url, "POST", {
      failureMessage: API_ENDPOINTS.LIST_LEDGER.failureMessage,
      data: { ownId: actorId, businessPartnerCode },
      thenCallBack: (response) => {
        setRowsData(response.data.ledgers);
      },
    });
  };

  const downloadSapLedgerData = async () => {
    await useFetch<ListLedgerResponse>(API_ENDPOINTS.LIST_LEDGER.url, "POST", {
      failureMessage: API_ENDPOINTS.LIST_LEDGER.failureMessage,
      showSuccessToast: true,
      data: { ownId: actorId, businessPartnerCode },
      thenCallBack: (response) => {
        setRowsData(response.data.ledgers);
        const worksheet1 = XLSX.utils.json_to_sheet(response.data.ledgers);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet1, "Sap Ledger data.");
        XLSX.writeFile(workbook, `Sap Ledger data.xlsx`);
      },
    });
  };

  const deleteSelectedRow = async () => {
    await useFetch(API_ENDPOINTS.DELETE_SAP_DATA.url, "DELETE", {
      failureMessage: API_ENDPOINTS.DELETE_SAP_DATA.failureMessage,
      showSuccessToast: true,
      config: {
        data: {
          ledgers: selectedRow,
        },
      },
      thenCallBack: () => {
        getListLedger();
      },
    });
  };

  return (
    <LoggedInSkeleton topBarButtons={getAdminTopBarButtons("Sap Data")}>
      <Grid style={{ paddingBottom: "40px" }}>
        <Grid className="center_align">
          <Card style={{ padding: "20px 40px", alignItems: "center" }} className="center_align">
            <TextField
              id="outlined-number"
              label="Own Id"
              type="number"
              value={actorId}
              onChange={(e: any) => setActorId(e.target.value)}
            />
            <TextField
              id="outlined-number"
              label="BusinessPartner code"
              type="number"
              style={{ margin: "0 40px" }}
              value={businessPartnerCode}
              onChange={(e: any) => setBusinessPartnerCode(e.target.value)}
            />
            <Button
              variant="contained"
              className="theme_btn"
              style={{
                width: "100px",
                height: "40px",
                margin: "auto 0",
              }}
              onClick={() => getListLedger()}
            >
              Submit
            </Button>
            <Button
              variant="contained"
              className="theme_btn tallyVoucher_submit_btn"
              onClick={() => downloadSapLedgerData()}
            >
              Download
            </Button>
          </Card>
        </Grid>

        {rowsData.length > 0 ? (
          <Grid>
            <Grid
              className="center_align"
              style={{
                paddingRight: "0px",
                paddingLeft: "0px",
                marginTop: "25px",
                width: "100%",
              }}
            >
              <Table
                columns={columnDefinition}
                rows={rowsData}
                sortEnable={true}
                setSelectedRow={setSelectedRow}
                actorType="admin"
                showPagination={true}
              />
            </Grid>
            <Grid className="center_align">
              <Button
                variant="contained"
                className="theme_btn"
                style={{
                  margin: "30px",
                }}
                onClick={() => deleteSelectedRow()}
              >
                Delete
              </Button>
            </Grid>
          </Grid>
        ) : null}
      </Grid>
    </LoggedInSkeleton>
  );
};

export default SapData;
